var render, staticRenderFns
import script from "./SizeQuantity.vue?vue&type=script&lang=js"
export * from "./SizeQuantity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e074556')) {
      api.createRecord('5e074556', component.options)
    } else {
      api.reload('5e074556', component.options)
    }
    
  }
}
component.options.__file = "src/scripts/components/basic/SizeQuantity.vue"
export default component.exports